import axios from './index'
import url from './url'

// 获取用户基本信息
function getUserInfo (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getUserInfo`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 修改用户基本信息
function updateUserInfo (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/updateUserInfo`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 修改用户基本信息
function updateUserPasword (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/updateUserPasword`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

export {
  getUserInfo,
  updateUserInfo,
  updateUserPasword
}



// WEBPACK FOOTER //
// ./src/axios/userInfo.js